<template>
  <div class="block" :class="classed" @click="doAction()">
    <div class="block-title d-flex mb-1">
      <svg width="14" height="24" viewBox="0 0 14 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-1" v-if="type == 'facebook'">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.48394 1.63625C6.60955 0.55612 8.165 0.0241699 9.90323 0.0241699C10.9746 0.0241699 12.1115 0.188334 13.114 0.342569L13.75 0.440408V5.39514H11.2194C10.4806 5.39514 10.2076 5.57915 10.096 5.7047C9.96941 5.84716 9.87903 6.10308 9.87903 6.58062V8.5403H13.7247L12.8653 13.9113H9.87903V23.6084L9.27612 23.729C8.45446 23.8933 7.631 23.9758 6.80645 23.9758C5.9819 23.9758 5.15845 23.8933 4.33678 23.729L3.73387 23.6084V13.9113H0.25V8.5403H3.73387V6.19352C3.73387 4.28506 4.3533 2.7212 5.48394 1.63625ZM6.52251 2.71855C5.73702 3.4723 5.23387 4.61812 5.23387 6.19352V10.0403H1.75V12.4113H5.23387V22.362C5.75881 22.4379 6.28292 22.4758 6.80645 22.4758C7.32998 22.4758 7.85409 22.4379 8.37903 22.362V12.4113H11.5863L11.9656 10.0403H8.37903V6.58062C8.37903 5.97429 8.48221 5.26247 8.97493 4.70815C9.48268 4.13693 10.2549 3.89514 11.2194 3.89514H12.25V1.73009C11.4481 1.61516 10.6478 1.52417 9.90323 1.52417C8.46726 1.52417 7.31303 1.95996 6.52251 2.71855Z" fill="#3C67FF" />
      </svg>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-1" v-if="type == 'helpCenter'">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M3 20.25C3.41421 20.25 3.75 20.5858 3.75 21C3.75 21.8284 4.42157 22.5 5.25 22.5H21C21.4142 22.5 21.75 22.8358 21.75 23.25C21.75 23.6642 21.4142 24 21 24H5.25C3.59315 24 2.25 22.6569 2.25 21C2.25 20.5858 2.58579 20.25 3 20.25Z" fill="#FFBB1C" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M2.25 5.25C2.25 3.17894 3.92894 1.5 6 1.5H12C12.4142 1.5 12.75 1.83579 12.75 2.25C12.75 2.66421 12.4142 3 12 3H6C4.75736 3 3.75 4.00736 3.75 5.25V18.4013C4.19126 18.1461 4.70357 18 5.25 18H20.25V3H18C17.5858 3 17.25 2.66421 17.25 2.25C17.25 1.83579 17.5858 1.5 18 1.5H20.25C21.0784 1.5 21.75 2.17157 21.75 3V17.9999C21.75 18.8283 21.0784 19.5 20.25 19.5H5.25C4.42157 19.5 3.75 20.1716 3.75 21H2.25V5.25Z" fill="#FFBB1C" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M19.5 18C19.9142 18 20.25 18.3358 20.25 18.75V23.25C20.25 23.6642 19.9142 24 19.5 24C19.0858 24 18.75 23.6642 18.75 23.25V18.75C18.75 18.3358 19.0858 18 19.5 18Z" fill="#FFBB1C" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M13.5 1.5C13.0858 1.5 12.75 1.83579 12.75 2.25V10.9393L14.4697 9.21967C14.6103 9.07902 14.8011 9 15 9C15.1989 9 15.3897 9.07902 15.5303 9.21967L17.25 10.9393V2.25C17.25 1.83579 16.9142 1.5 16.5 1.5H13.5ZM11.25 2.25C11.25 1.00736 12.2574 0 13.5 0H16.5C17.7426 -1.78814e-07 18.75 1.00736 18.75 2.25V12.75C18.75 13.0533 18.5673 13.3268 18.287 13.4429C18.0068 13.559 17.6842 13.4948 17.4697 13.2803L15 10.8107L12.5303 13.2803C12.3158 13.4948 11.9932 13.559 11.713 13.4429C11.4327 13.3268 11.25 13.0533 11.25 12.75V2.25Z" fill="#FFBB1C" />
      </svg>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-1" v-if="type == 'liveChat'">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M3.75 9.75C2.50736 9.75 1.5 10.7574 1.5 12V15C1.5 16.2426 2.50736 17.25 3.75 17.25H4.5L4.5 9.75H3.75ZM0 12C-2.98023e-07 9.92894 1.67894 8.25 3.75 8.25H4.5C5.32843 8.25 6 8.92157 6 9.75V17.25C6 18.0784 5.32843 18.75 4.5 18.75H3.75C1.67894 18.75 0 17.0711 0 15V12Z" fill="#06E884" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M18 9.75C18 8.92157 18.6716 8.25 19.5 8.25H20.25C22.3211 8.25 24 9.92894 24 12V15C24 17.0711 22.3211 18.75 20.25 18.75H19.5C18.6716 18.75 18 18.0784 18 17.25V9.75ZM20.25 17.25C21.4926 17.25 22.5 16.2426 22.5 15V12C22.5 10.7574 21.4926 9.75 20.25 9.75L19.5 9.75V17.25H20.25Z" fill="#06E884" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M12 1.5C7.85786 1.5 4.5 4.85786 4.5 9C4.5 9.41421 4.16421 9.75 3.75 9.75C3.33579 9.75 3 9.41421 3 9C3 4.02944 7.02944 0 12 0C16.9706 -8.34465e-07 21 4.02944 21 9C21 9.41422 20.6642 9.75 20.25 9.75C19.8358 9.75 19.5 9.41422 19.5 9C19.5 4.85786 16.1421 1.5 12 1.5Z" fill="#06E884" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M20.25 17.25C20.6642 17.25 21 17.5858 21 18V18.75C21 20.8211 19.3211 22.5 17.25 22.5H15C14.5858 22.5 14.25 22.1642 14.25 21.75C14.25 21.3358 14.5858 21 15 21H17.25C18.4926 21 19.5 19.9926 19.5 18.75V18C19.5 17.5858 19.8358 17.25 20.25 17.25Z" fill="#06E884" />
        <path fill-rule="evenodd" clip-rule="evenodd" d="M12 21C11.5858 21 11.25 21.3358 11.25 21.75C11.25 22.1642 11.5858 22.5 12 22.5H13.5C13.9142 22.5 14.25 22.1642 14.25 21.75C14.25 21.3358 13.9142 21 13.5 21H12ZM13.5 24H12C10.7574 24 9.75 22.9926 9.75 21.75C9.75 20.5074 10.7574 19.5 12 19.5H13.5C14.7426 19.5 15.75 20.5074 15.75 21.75C15.75 22.9926 14.7426 24 13.5 24Z" fill="#06E884" />
      </svg>

      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="mr-1" v-if="type == 'youtube'">
        <g>
          <path fill-rule="evenodd" clip-rule="evenodd" d="M0 7.44C0 5.12593 1.87593 3.25 4.19 3.25H19.81C22.1241 3.25 24 5.12593 24 7.44V16.56C24 18.8741 22.1241 20.75 19.81 20.75H4.19C1.87593 20.75 3.57628e-07 18.8741 0 16.56V7.44ZM19.81 4.75H4.19C2.70435 4.75 1.5 5.95435 1.5 7.44V16.56C1.5 18.0456 2.70435 19.25 4.19 19.25H19.81C21.2956 19.25 22.5 18.0456 22.5 16.56V7.44C22.5 5.95435 21.2956 4.75 19.81 4.75ZM9.13985 6.62213C9.38023 6.49054 9.67324 6.50052 9.90411 6.64818L16.6741 10.9782C16.8896 11.116 17.02 11.3542 17.02 11.61C17.02 11.8658 16.8896 12.104 16.6741 12.2418L9.90411 16.5718C9.67324 16.7195 9.38023 16.7295 9.13985 16.5979C8.89947 16.4663 8.75 16.214 8.75 15.94V7.28C8.75 7.00596 8.89947 6.75373 9.13985 6.62213ZM10.25 8.64997V14.57L14.878 11.61L10.25 8.64997Z" fill="#FF5353" />
        </g>
      </svg>

      <span>{{ title }}</span>
    </div>
    <p class="block-content typo-paragraph14 typo-regular typo-lh150">{{ content }}</p>
  </div>
</template>
<script>
import { mapActions } from "vuex";
export default {
  name: "FaqsBlock",
  props: {
    type: String
  },
  computed: {
    title() {
      if (this.type == "facebook") {
        return "Facebook";
      }
      if (this.type == "helpCenter") {
        return "Help Center";
      }
      if (this.type == "youtube") {
        return "Youtube";
      }
      return "Live Chat";
    },
    content() {
      if (this.type == "facebook") {
        return this.$t("faqs.block.facebook.content");
      }
      if (this.type == "helpCenter") {
        return this.$t("faqs.block.helpCenter.content");
      }
      if (this.type == "youtube") {
        return this.$t("faqs.block.youtube.content");
      }
      return this.$t("faqs.block.liveChat.content");
    },
    classed() {
      if (this.type == "facebook") {
        return { "block-facebook": true };
      }
      if (this.type == "helpCenter") {
        return { "block-help-center": true };
      }
      if (this.type == "youtube") {
        return { "block-youtube": true };
      }
      return { "block-live-chat": true };
    }
  },
  methods: {
    ...mapActions("tutorial", {
      closeFaqModal: "closeFaqsModal"
    }),
    doAction() {
      // this.closeFaqModal();
      if (this.type == "facebook") {
        window.open("https://www.facebook.com/groups/105491389940833/", "_blank");
      }
      if (this.type == "helpCenter") {
        window.open("https://help.gempages.net/", "_blank");
      }
      if (this.type == "youtube") {
        window.open("https://www.youtube.com/channel/UCRUP8zvEDtEJrRtqCjbLJ0w", "_blank");
      }
      if (this.type == "liveChat") {
        this.$chatbox.show();
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
